function getListWidthWatch (to, style, length = 0) {
  // If route has child elements set width to 20%
  if (Object.getOwnPropertyNames(to.params).length > length || window.location.pathname.split('/').pop() === 'create') {
    style.transition = '.5s'
    style.width = '30%'
  } else { // Else display it in full width
    style.width = '100%'
    style.transition = '.5s'
  }

  // After animation disable animation because we need multipane-resizer to work without animations
  setTimeout(() => {
    style.transition = '0s'
  }, 500)
}

function getListWidthCreated (params, style, length = 0) {
  // If route has child elements set width to 20%
  if (Object.getOwnPropertyNames(params).length > length || window.location.pathname.split('/').pop() === 'create') {
    style.width = '30%'
  }
}

export {getListWidthWatch, getListWidthCreated}



// WEBPACK FOOTER //
// ./src/helpers/listWidth.js